import React from 'react'
import { Text } from '@mantine/core'
import IonIcon from '@reacticons/ionicons'


type FormHeaderProps = {
  title?: string
  subtitle?: string
  withCloseIcon?: boolean
  closeModal?: () => void
}

function FormHeader({ title, subtitle, withCloseIcon, closeModal }: FormHeaderProps) {
  return (
    <div className="form-header">

      <div className="form-header-title-header">
        <div className="form-header-title">
          <Text className="form-header-title-text">{title}</Text>
        </div>
        {withCloseIcon && (
             <div className="form-header-title-header-close-icon">
               <IonIcon
                 className='drawerCloseButton'
                 name="close-circle"
                 onClick={closeModal}
            />
          </div>
        )}
        </div>
        {subtitle && (
          <div className="form-header-subtitle">
            <Text className="form-header-subtitle-text">{subtitle}</Text>
          </div>
        )}
      </div>
  )
}

export default FormHeader